import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const convertToDayjs = (date: Date | string, format: ?string) =>
  format ? dayjs(date, format) : dayjs(date);

export default convertToDayjs;
